// eslint-disable-next-line func-names
(function (ss, ex) {
  // eslint-disable-next-line func-names
  window.ldfdr = window.ldfdr || function () {
    // eslint-disable-next-line no-undef,no-underscore-dangle,prefer-rest-params
    (ldfdr._q = ldfdr._q || []).push([].slice.call(arguments));
  };
  // eslint-disable-next-line func-names
  (function (d, s) {
    // eslint-disable-next-line no-undef,prefer-destructuring
    fs = d.getElementsByTagName(s)[0];

    function ce(src) {
      const cs = d.createElement(s);
      cs.src = src;
      cs.async = 1;
      // eslint-disable-next-line no-undef
      fs.parentNode.insertBefore(cs, fs);
    }

    ce(`https://sc.lfeeder.com/lftracker_v1_${ss}${ex ? `_${ex}` : ''}.js`);
  }(document, 'script'));
}('p1e024BvknJ4GB6d'));
